<template>
  <div style="max-width: 1200px">

    <h3>英雄列表 <span style="font-size:12px">（版本: {{ dragontail.version }}）</span></h3>

    <table class="ui celled table striped black center aligned">
      <tr style="height: 68px; font-weight: bold">
        <td>LOGO</td>
        <td>名字</td>
        <td>称号</td>
        <td>ID</td>
        <td>KEY</td>
        <td>Tags</td>
      </tr>
      <tr v-for="champion in champions" :key="champion.key" style="height: 68px">
        <td>
          <img :src="dragontail.generate_champion_logo_url(champion.id)" style="width: 40px; height: 40px" />
        </td>
        <td>{{ champion.title }}</td>
        <td>{{ champion.name }}</td>
        <td>{{ champion.id }}</td>
        <td>{{ champion.key }}</td>
        <td>{{ lodash.join(champion.tags, " ") }}</td>
      </tr>
    </table>

  </div>
</template>

<script>

  import lodash from "lodash"
  // import axios from "axios"
  
  import dragontail from "@/utils/dragontail.js"

  export default {
    data: function(){
      return {
        champions: []
      }
    },
    mounted: function(){

      // this.test_promise_all()

      this.init()
    },
    computed: {
      dragontail: function(){
        return dragontail
      },
      lodash: function(){
        return lodash
      }
    },
    methods: {
      init: async function(){

        // console.log("init")

        var thisApp = this

        var newChampions = await dragontail.async_get_or_fetch_champions()

        thisApp.champions = newChampions
      },
      test_promise_all: async function(){

        var fetch3 = this.fetch_slow_data(3000)
        console.log("fetch3")
        console.log(fetch3)

        var fetch2 = this.fetch_slow_data(2000)
        console.log("fetch2")
        console.log(fetch2)

        var fetch1 = this.fetch_slow_data(1000)
        console.log("fetch1")
        console.log(fetch1)

        var t0 = Date.now()

        Promise.all([fetch3, fetch2, fetch1]).then(function(values) {

          var data3, data2, data1

          [data3, data2, data1] = values

          console.log(data3)
          console.log(data2)
          console.log(data1)

          var t1 = Date.now()

          var timeSpend = t1 - t0
          console.log("time spend: " + timeSpend)

        })
      },
      fetch_slow_data: async function(milSeconds){

        return new Promise((resolve) => {

          setTimeout(function(){
            resolve("data_" + milSeconds);
          }, milSeconds)
        })
      },
    }
  }

</script>



